/*
This view represents the container of the portfolios section and
thus handles things like the overall size of the section and 
locking the section into place upon scroll. It does not handle
the inner workings of each portfolio or the items within it.
*/

(function($) {
	var PortfoliosView = Backbone.View.extend(_.extend({}, App._base, {
		el: '.portfolios-section',

		// Put variables here

		portfolios: null,
		navigation: null,
		activeClass: 'active',
		currentPortfolio: 0,
		progressDebounce: 0,
		inProgress: false,

		ScrollMagicController: null,
		ScrollMagicScene: null,
		scrollSensitivity: .85,

		$title: null,
		$subtitle: null,
		$content: null,

		PortfolioViews: null,

		// Put functionality here

		SetScrollLock: function() {
			if (this.isTablet()) {
				this.DestroyScroll();
			} else {
				this.InitializeScroll();
			}
		},

		InitializeScroll: function() {
			if (this.ScrollMagicController) { return; }

			var wh = $(window).height(),
				offset = wh / 2;

			this.ScrollMagicController = new ScrollMagic.Controller();

			this.ScrollMagicScene = new ScrollMagic.Scene({
				triggerElement: this.el,
				offset: offset,
				duration: wh * this.portfolios.length * this.scrollSensitivity
			})
				.setPin(this.el)
				.addTo(this.ScrollMagicController)
				.on('enter', this.proxy(function(e) {
					this.OnScrollMagicStart();
					this._SetNavigation(this.currentPortfolio);
				}))
				.on('leave', this.proxy(function(e) {
					this.OnScrollMagicEnd();
				}))
			;
		},

		DestroyScroll: function() {
			if (this.ScrollMagicController) {
				this.ScrollMagicController.destroy(true);
				this.ScrollMagicController = null;
				this.portfolios.removeAttr('style');
			}
		},

			OnScrollMagicStart: function() {
				this.ScrollMagicScene.on('update', this.proxy(this.OnScrollMagicUpdate));
			},
			OnScrollMagicEnd: function(e) {
				this.ScrollMagicScene.off('update');
			},

				OnScrollMagicUpdate: function(e) {
					var tot = e.endPos - e.startPos,
						pos = (e.scrollPos - e.startPos) / tot,
						index = Math.floor(pos * this.portfolios.length);

					if (index !== this.currentPortfolio) {
						this.SwitchPortfolio(index, e.scrollDirection);
					}
				},

			// Scroll the window and let scrollmagic events handle switching the portfolio
			ScrollToPortfolio: function(index) {
				// Need to select parent of this.$el because that's the ScrollMagic wrapper.
				// NOTE: Be very careful of this if ScrollMagic changes.
				var t = this.$el.parent().offset().top,
					wh = $(window).height();

				// The 5 is just to make sure it's over the line. TODO: Figure out a better solution for that.
				t += (Math.round(wh * index * this.scrollSensitivity) * (1 + this.scrollSensitivity * .25));

				TweenMax.to(window, .5, { scrollTo: { y: t }, ease: Linear.easeInOut });
			},

				_SetNavigation: function(index) {
					var $ni = this.navigation.eq(index),
						id = $ni.prop('id').replace('-portfolio', '');

					//App.Routes.navigate('/portfolios/'+id, false, true);
				},

			SwitchPortfolio: function(index, direction) {
				// Security check
				if (index < 0 || index >= this.portfolios.length) {
					return;
				}

				this._SetNavigation(index);

				var $cp = this.portfolios.eq(this.currentPortfolio),
					$np = this.portfolios.eq(index),
					sH = this.$el.height() * .1;
				if (direction === 'REVERSE') {
					sH = -(sH);
				}

				this.portfolios.not($cp).css({ 'opacity': 0, 'z-index': 0 });
				$cp.css('z-index', 1);
				$np.css('z-index', 2);

				this.currentPortfolio = index; 

				TweenMax.to($np, 1, { css: { opacity: 1 }, startAt: { opacity: 0 }, ease: Quad.easeOut });

				var tY = { y: sH };
				TweenMax.to(tY, .5, { y: 0, ease: Quad.easeOut,
					onUpdate: this.proxy(function(e) {
						$np.css('transform', 'translateY('+tY.y+'px)');
					}), onComplete: this.proxy(function(e) {
						this.SetActivePortfolio();
					})
				});
			},

			SetActivePortfolio: function() {
				this.portfolios.removeClass(this.activeClass);
				this.portfolios.eq(this.currentPortfolio).addClass(this.activeClass);

				this.navigation.removeClass(this.activeClass);
				this.navigation.eq(this.currentPortfolio).addClass(this.activeClass);

				this.PopulateContent();
				this.SetPortfolioOrder();

				App.Events.trigger('portfolio-selected', { index: this.currentPortfolio }); 
			},

				SetPortfolioOrder: function() {
					var $cp = this.portfolios.eq(this.currentPortfolio);

					this.portfolios.css('z-index', 0);
					$cp.css('z-index', 1);
				},

				PopulateContent: function() {
					var $cp = this.portfolios.eq(this.currentPortfolio),
						$it = $('.entry-title', $cp),
						$is = $('.entry-subtitle', $cp),
						$ic = $('.entry-content', $cp);

					TweenMax.allTo([this.$title, this.$subtitle, this.$content], .5, {opacity: 0, y: '-20px', ease: Power2.easeOut, onComplete: this.proxy(function(e) {
						this.$title.html($it.html());
						this.$subtitle.html($is.html());
						this.$content.html($ic.html());
						
						TweenMax.to(this.$title, .8, { opacity: 1, y: 0, startAt: { y: '+20px' }, ease: Power2.easeOut });
						TweenMax.to(this.$subtitle, .8, { opacity: 1, y: 0, startAt: { y: '+20px' }, delay: .2, ease: Power2.easeOut });
						TweenMax.to(this.$content, .8, { opacity: 1, y: 0, startAt: { y: '+20px' }, delay: .4, ease: Power2.easeOut });
					})});
				},

		SetSectionHeight: function() {
			if (!this.isTablet()) {
				var wh = $(window).height();
				this.$el.height(wh); // Notice it takes the entire window height
			} else {
				this.$el.removeAttr('style');
			}
		},

		PortfolioItemClicked: function(e) {
			e.preventDefault();
			var $$ = $(e.currentTarget),
				ind = $$.index();

			if (ind !== this.currentPortfolio) {
				this.ScrollToPortfolio(ind);
			}
		},

		OnPortfolioRequest: function(ind) {
			console.log('OnPortfolioRequest...', ind);
			if (ind !== this.currentPortfolio) {
				this.ScrollToPortfolio(ind);
			}
		},

		// TODO: Inherit all the resize stuff
		OnWindowResize: function(e) {
			clearTimeout(this.resizeDebounce);
			this.resizeDebounce = setTimeout(this.proxy(function() {
				this.SetScrollLock();
				this.SetSectionHeight();
			}), 250);
		},

		bindEvents: function() {
			$(window).resize(this.proxy(this.OnWindowResize));
			this.navigation.click(this.proxy(this.PortfolioItemClicked));

			App.Events.on('portfolioRequest', this.proxy(this.OnPortfolioRequest));
		},

		ready: function() {
			this.bindEvents();
			this.SetSectionHeight();
			this.SetScrollLock();
		},

		initialize: function(options) {
			this.PortfolioView = new App._PortfolioView({el: this.el});

			this.portfolios = $('.portfolio-item', this.$el);
			this.navigation = $('.portfolios-navigation a', this.$el);
			var $container = $('.content-container', this.$el);
				this.$title = $('.entry-title', $container);
				this.$subtitle = $('.entry-subtitle', $container);
				this.$content = $('.entry-content', $container);

			this.SetActivePortfolio();

			App.Events.on('ready', this.proxy(this.ready));
		}
	}));

	App.Views.Portfolios = new PortfoliosView();
})(jQuery);  